import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs } from "../../components/core/Breadcrumbs";
import { UpsertReconciliationMappingForm } from "../../features/parameters/reconciliation-mapping/UpsertReconciliationMappingForm";
import { AuthenticatedLayout } from "../../features/user/layouts/AuthendicatedLayout";

export const EditReconciliationMapping = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, [id, navigate]);

  return (
    <AuthenticatedLayout>
      <Breadcrumbs />
      <UpsertReconciliationMappingForm id={id} />
    </AuthenticatedLayout>
  );
};
